import { Loader2 } from 'lucide-react';
import React from 'react';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useDashboardContext } from './DashboardContext';
import { formatTooltipMoney } from './helpers';

export const TrendAreaChartCard: React.FC = () => {
  const { dashboard, loadingStates } = useDashboardContext();
  return (
    <div className="flex flex-col rounded-[22px] border border-slate-100 bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.02)] lg:col-span-2">
      <h3 className="text-[13px] font-semibold text-slate-900">Sales Trend</h3>
      <div className="mt-3 min-h-[170px] w-full flex-1">
        {loadingStates.summary ? (
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="animate-spin text-slate-300" size={24} />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={dashboard.trend}>
              <defs>
                <linearGradient id="netSales" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#15803d" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#15803d" stopOpacity={0.0} />
                </linearGradient>
              </defs>
              <CartesianGrid stroke="#f1f5f9" vertical={false} />
              <XAxis
                dataKey="label"
                tickLine={false}
                axisLine={false}
                tick={{ fill: '#94a3b8', fontSize: 10 }}
              />
              <YAxis
                tickLine={false}
                axisLine={false}
                tick={{ fill: '#94a3b8', fontSize: 10 }}
                tickFormatter={(val) => `${Math.round(val / 1000)}k`}
                width={30}
              />
              <Tooltip
                formatter={(value) => formatTooltipMoney(value)}
                contentStyle={{
                  borderRadius: 12,
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                }}
              />
              <Area
                type="monotone"
                dataKey="net_sales"
                stroke="#15803d"
                strokeWidth={3}
                fill="url(#netSales)"
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};
